module.exports = __webpack_public_path__ + "img/3_28.da9365be.png";